import {Routes} from '@wallex-core/constants/routes.enum';

export const referralProgramMenuItem = {
  label: 'rewards.invite-a-friend',
  icon: 'invite-menuitem',
  routerLink: [Routes.settings],
  routerLinkActiveOptions: {exact: true},
  queryParams: {tab: 2}
};
